// mloData.js

export const MloDetails = [
    {
        name: "John Doe",
        nmlsId: "12345",
        companyName: "ABC Mortgage",
        phone: "123-456-7890",
        email: "john@example.com",
        website: "www.example.com",
        state: "AL"
    },
    {
        name: "Jane Smith",
        nmlsId: "67890",
        companyName: "XYZ Mortgage",
        phone: "987-654-3210",
        email: "jane@example.com",
        website: "www.xyzmortgage.com",
        state: "CA"
    },
    {
        name: "Michael Johnson",
        nmlsId: "54321",
        companyName: "123 Lending",
        phone: "555-555-5555",
        email: "michael@example.com",
        website: "www.123lending.com",
        state: "CA"
    },
    {
        name: "John Doe",
        nmlsId: "12345",
        companyName: "ABC Mortgage",
        phone: "123-456-7890",
        email: "john@example.com",
        website: "www.example.com",
        state: "AL"
    },
    {
        name: "Jane Smith",
        nmlsId: "67890",
        companyName: "XYZ Mortgage",
        phone: "987-654-3210",
        email: "jane@example.com",
        website: "www.xyzmortgage.com",
        state: "CA"
    },
    {
        name: "Michael Johnson",
        nmlsId: "54321",
        companyName: "123 Lending",
        phone: "555-555-5555",
        email: "michael@example.com",
        website: "www.123lending.com",
        state: "CA"
    },
    {
        name: " Doe",
        nmlsId: "12345",
        companyName: "ABC Mortgage",
        phone: "123-456-7890",
        email: "john@example.com",
        website: "www.example.com",
        state: "AL"
    },
    {
        name: " Smith",
        nmlsId: "67890",
        companyName: "XYZ Mortgage",
        phone: "987-654-3210",
        email: "jane@example.com",
        website: "www.xyzmortgage.com",
        state: "CA"
    },
    {
        name: " Johnson",
        nmlsId: "54321",
        companyName: "123 Lending",
        phone: "555-555-5555",
        email: "michael@example.com",
        website: "www.123lending.com",
        state: "CA"
    },
];
